import { ObjectList } from "web/components"
import useViewOrEditTopicModal from "web/components/ViewOrEdit/ViewOrEditTopic"

import {
  useAddDealComparables,
  useFeatureFlag,
  useFindComparableTopicRecordsView,
  useTopics,
} from "web/hooks/data"

import { useCurrentTLO } from "web/hooks/context"
import { NavigationProvider } from "web/contexts"

import FindComparablesActions from "../shared/FindComparablesActions"
import routes from "web/routes/constants"

export default function FindComparables({
  subjectType,
  topicName,
  baseUrl,
  canRedirectToRootUrl,
}) {
  const { userCan, data: deal } = useCurrentTLO()
  const userCanAddComparables = userCan("update")

  const topics = useTopics()
  const topic = topics.find(
    (topic) =>
      topic.subject_type.toLowerCase() === subjectType &&
      topic.name === topicName
  )

  const [view] = useFindComparableTopicRecordsView({ deal, topic })

  const addComparables = useAddDealComparables({ deal, topic })

  const useSSRTopicRecordModals = useFeatureFlag("ssr_topic_record_modals")

  const viewOrEditTopicModal = useViewOrEditTopicModal({ subjectType, topic })

  const backToComparablesUrl = baseUrl.split("/find")[0]

  async function handleTopicRecordClick(record, list) {
    if (useSSRTopicRecordModals) {
      window.Turbo.visit(
        routes.ssrEditTopicRecord({
          subjectType: subjectType,
          subjectId: record.subject_id,
          topicName: topicName,
          id: record.id,
          isCrossSubject: true,
        }),
        {
          frame: "modal",
        }
      )
    } else {
      await viewOrEditTopicModal({
        recording: record,
        isCrossSubject: true,
      })

      list.refresh()
    }
  }

  return (
    <NavigationProvider viewGroup={{}} viewId={view.id}>
      <div className="-mx-3 flex min-h-0 grow flex-col lg:-mx-5">
        <ObjectList
          subjectType={subjectType}
          topic={topic}
          parentSubjectId={deal.id}
          parentSubjectType="deal"
          fetchURL={`/deals/${deal.id}/comparables/topics/${topic.id}/available_records`}
          availableViews={["table", "map", "compare"]}
          defaultView="table"
          listType="deal_find_comparable_topic_records"
          showBreadcrumbNav={false}
          enableExport={false}
          onItemClick={handleTopicRecordClick}
          customListActions={
            <FindComparablesActions
              userCanAddComparables={userCanAddComparables}
              addComparables={addComparables}
              backUrl={backToComparablesUrl}
            />
          }
          rootUrl={baseUrl}
          canRedirectToRootUrl={canRedirectToRootUrl}
          breadcrumbs={[
            { name: "Comparables", href: backToComparablesUrl },
            { name: "Find Comparables", href: null },
          ]}
        />
      </div>
    </NavigationProvider>
  )
}
